import React, {useEffect} from 'react';
import "./Contact.scss";
import {ReactComponent as EmailIcon} from "../../../assets/images/contact-email.svg";
import {useHistory} from "react-router-dom";
import {isUserAuthenticated} from "../../../redux/actions/authentication";
import {useSelector} from "react-redux";

const Contact = () => {
  const history = useHistory();
  const demo = useSelector(state => state.demo);

  useEffect(() => {
    !isUserAuthenticated() && !demo.isDemoMode && history.push("/login");
  }, [history, demo.isDemoMode]);

  return (
    <div className="Contact">
      <div className="contact-wrapper">
        <div className="contact-header">
          <p className="contact-header__label">Suporte</p>
          <h1>Entre em contato</h1>
          <p className="contact-header__subtitle">
            Nossa equipe está pronta para te ajudar com o que precisar.
          </p>
        </div>

        <div className="contact-card">
          <a className="contact-card__link" href="mailto:oi@mastertech.com.br">
            <span className="contact-card__link-icon">
              <EmailIcon />
            </span>
            <div className="contact-card__link-content">
              <span className="contact-card__link-label">E-mail</span>
              <span className="contact-card__link-value">oi@mastertech.com.br</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
